import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../actions'
import searchDecode from '../../helpers/searchDecode'
import { doTrack } from '../../helpers/TaggingSerializer'

import LoadingWheel from '@argos/loading-wheel'
import Sidebar from '../../components/Sidebar/Sidebar'
import LoadingError from '../../components/LoadingError/LoadingError'
import Helmet from 'react-helmet'
import SearchBar from '../../components/SearchBar/SearchBar'

import './Search.scss'

class HelpFAQ extends PureComponent {
  static waitForDataServer (dispatch, params, req, res) {
    return Promise
      .all([
        dispatch(actions.fetchSidebarNav(true)),
        dispatch(actions.fetchFAQBySearch(params.searchTerm, true))
      ])
  }

  static waitForDataClient (store) {
    return (nextState, transition, callback) => {
      const { dispatch, getState } = store
      const { params } = nextState
      const faq = getState().faq

      if (faq.searchTerm === params.searchTerm) {
        return callback()
      }

      dispatch(actions.fetchFAQBySearch(params.searchTerm))
        .then(() => { callback() })
        .catch(() => { callback() })
    }
  }

  constructor () {
    super()

    this.state = {
      searchTerm: ''
    }
  }

  componentWillReceiveProps (newProps) {
    if (this.props.routeParams.searchTerm !== newProps.routeParams.searchTerm) {
      this.fireAnalytics()
    }
  }

  componentDidMount () {
    this.fetchData(this.props.routeParams.searchTerm)
    this.fireAnalytics()
  }

  fireAnalytics = () => {
    if (window.digitalData) {
      window.digitalData.page.pageInfo.pageName = 'ar:help:faq:searchResults:'
      window.digitalData.page.pageInfo.templateTitle = 'FAQ_SearchResults'
    }

    doTrack('help_initialLoad')
  }

  fetchData = (newSearchTerm) => {
    const { actions, sidebar } = this.props

    if (!sidebar.length) actions.fetchSidebarNav()
  }

  render () {
    const { error, sidebar, searchResults, searchTerm, loading } = this.props

    if (error) return <LoadingError />
    if (!searchTerm) return <LoadingWheel />

    const ccn = 'search'
    const pageCcn = 'page'
    const metaData = {
      title: 'Help & FAQ - Search Results for "' + searchDecode(searchTerm) + '"',
      meta: [{ name: 'robots', content: 'NOINDEX' }]
    }

    return (
      <div className={ccn + ' ' + pageCcn + ' container'}>
        <div id='helpfaqcontent' tabIndex='-1' />
        <Helmet {...metaData} />
        <div className='xs-row xs-row--negative lg-row'>
          <Sidebar links={sidebar} loading={loading} />

          <div className='xs-12 lg-9 content'>
            <SearchBar />
            <h2 className='page__title page__title--search'>Search results for: '{searchDecode(searchTerm)}'</h2>
            <div className={ccn + '__results'}>
              {
                searchResults.length > 0 && searchResults.map((result, index) => {
                  return (
                    <a className={ccn + '__link ' + ccn + '__link--' + index} href={result.url + '?search=' + this.props.searchTerm} key={index} aria-label={result.value}>
                      <h6 className={ccn + '__title'}>{result.value}</h6>
                      <p className={ccn + '__desc'}>
                        <span className={ccn + '__readmore'}>Read more</span>
                      </p>
                    </a>
                  )
                })
              }
              {
                searchResults.length === 0 &&
                <p className={ccn + '__no-results-message'}>The term you chose confused our site. We'd really like to put things right so please do try a different word. A simpler, clearer one is preferred.</p>
              }
            </div>

          </div>
        </div>
      </div>
    )
  }
}

HelpFAQ.propTypes = {
  error: PropTypes.bool,
  sidebar: PropTypes.array,
  searchResults: PropTypes.array,
  searchTerm: PropTypes.string,
  searchTotalResults: PropTypes.number,
  loading: PropTypes.bool,
  actions: PropTypes.object,
  routeParams: PropTypes.object
}

function mapStateToProps (state) {
  return {
    sidebar: state.help.sidebar,
    searchResults: state.faq.searchResults,
    searchTerm: state.faq.searchTerm,
    searchTotalResults: state.faq.searchTotalResults,
    error: state.faq.searchError,
    loading: state.faq.searchLoading
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpFAQ)
